module.exports = __webpack_public_path__ + "static/media/logo.aa1b43bf.png";